const testimonials = [
  {
    name: '李女士',
    role: '两娃妈妈 · 上海',
    avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20mother%20age%2032%20warm%20friendly%20smile%20portrait%20professional%20clean%20white%20background%20high%20quality&width=120&height=120&seq=testimonial-1&orientation=squarish',
    quote: '用了习惯星球三个月，儿子的早起问题彻底解决了！以前每天催他起床真的要崩溃，现在他自己7点就爬起来了，就为了拿那2颗星星。最感动的是他存了150颗星星，跟我说想换一次全家去游乐园。那一刻我觉得这个方法真的太棒了。',
    highlight: '早起问题彻底解决',
    rating: 5
  },
  {
    name: '张先生',
    role: '三孩爸爸 · 北京',
    avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20father%20age%2035%20confident%20smile%20portrait%20professional%20clean%20white%20background%20high%20quality&width=120&height=120&seq=testimonial-2&orientation=squarish',
    quote: '我和媳妇两地跑，之前孩子的管理很混乱。用了这个系统后，连爷爷奶奶也可以参与记录，大家在同一套规则下，孩子感受到整个家庭的一致性，效果非常显著。AI助手功能特别好用，奶奶直接说话就能记录。',
    highlight: 'AI助手奶奶也会用',
    rating: 5
  }
];

export default function TestimonialsSection() {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-br from-[#f0f4ff] to-[#e8f0fe]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-white text-[#1a56db] text-sm px-4 py-2 rounded-full mb-4 font-medium shadow-sm">
            <i className="ri-star-fill text-amber-400"></i>
            <span>用户真实反馈</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#0d2d6e] mb-4">听听家长们怎么说</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-3xl p-8" style={{boxShadow:'0 2px 20px rgba(26,86,219,0.08)'}}>
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <div className="mb-4 inline-flex items-center gap-2 bg-blue-50 text-[#1a56db] text-xs font-medium px-3 py-1 rounded-full">
                <i className="ri-double-quotes-l"></i>
                {t.highlight}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 relative">
                <i className="ri-double-quotes-l text-4xl text-blue-100 absolute -top-2 -left-1 leading-none"></i>
                <span className="relative z-10">{t.quote}</span>
              </p>
              <div className="flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <div className="font-bold text-[#0d2d6e] text-sm">{t.name}</div>
                  <div className="text-gray-400 text-xs">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
